import React from 'react'
import './Faq.css'

const Faq = () => {
  return (
    <div>
      <h1 className='display-3 faq-head'>Frequently asked questions</h1>
      <p className='faq question'>Lorem ipsum?</p>
      <p className='faq answer'>
        Dolor sit amet! consectetur adipisicing elit. Odio qui unde voluptatum,
        maxime aspernatur saepe dolorum reiciendis officiis pariatur nesciunt ad
        ipsum illo veniam? Saepe aut ex porro modi doloremque!
      </p>

      <p className='faq question'>Maxime aspernatur saepe dolorum?</p>
      <p className='faq answer'>
        Adipisicing elit, quasi inventore itaque reiciendis iusto pariatur ullam
        deleniti esse accusantium quaerat incidunt reprehenderit, ad eos
        quibusdam maiores, molestiae ex? Perspiciatis, tempore quisquam.
      </p>

      <p className='faq question'>
        Incidunt reprehenderit, ad eos quibusdam maiores?
      </p>
      <p className='faq answer'>
        Ad eos quibusdam maiores, molestiae ex? Perspiciatis, tempore quisquam.{' '}
      </p>
    </div>
  )
}

export default Faq
